<template>
  <div
    class="ui huge button"
    @click="handleClick"
  >
    <i
      v-if="icon.length > 0"
      id="icons"
      :class="icon[currentIndex] + ' icon'"
      :data-identifier="identifier"
    />
    <span
      v-else
      :data-identifier="identifier"
    >
      {{ title[currentIndex] }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'ControlPanelButton',
  props: {
    icon: {
      type: Array,
      default: function () {
        return []
      },
    },
    identifier: {
      type: String,
      default: '',
    },
    title: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data: function () {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    nextIndex: function () {
      let next = this.currentIndex + 1
      if (next === Math.max(this.icon.length, this.title.length)) {
        next = 0
      }
      return next
    },
  },
  methods: {
    handleClick: function () {
      const oldIndex = this.currentIndex
      this.currentIndex = this.nextIndex
      this.$emit('button-click', this.identifier, oldIndex, this.currentIndex)
    },
  },
}
</script>
<style scoped>
@media only screen and (min-width: 500px) and (max-width: 920px) {
  .ui.huge.button {
    padding: 10px;
    margin-right: 15px;
  }
}

@media only screen and (min-width: 319px) and (max-width: 500px) {
  #icons {
    width: 20px;
    height: 20px;
  }

  .ui.huge.button {
    padding-top: 1px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 5px;
    margin-right: 15px;
  }
}
</style>
